/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as PortalRouteRouteImport } from './routes/portal/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PortalUserRouteImport } from './routes/portal/user'
import { Route as PortalDashboardRouteImport } from './routes/portal/dashboard'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthCreateAccountRouteImport } from './routes/auth/create-account'
import { Route as AuthConfirmEmailCodeRouteImport } from './routes/auth/confirm-email-code'
import { Route as PortalProjectsIndexRouteImport } from './routes/portal/projects/index'
import { Route as PortalDatasetsIndexRouteImport } from './routes/portal/datasets/index'
import { Route as PublicDatasetsIndexRouteImport } from './routes/_public/datasets/index'
import { Route as PortalProjectsCreateRouteImport } from './routes/portal/projects/create'
import { Route as PortalDatasetsCreateRouteImport } from './routes/portal/datasets/create'
import { Route as PublicDatasetsDatasetIdRouteImport } from './routes/_public/datasets/$datasetId'
import { Route as PortalProjectsProjectIdIndexRouteImport } from './routes/portal/projects/$projectId/index'
import { Route as PortalDatasetsDatasetIdIndexRouteImport } from './routes/portal/datasets/$datasetId/index'
import { Route as PortalProjectsProjectIdUsersRouteImport } from './routes/portal/projects/$projectId/users'
import { Route as PortalProjectsProjectIdEditRouteImport } from './routes/portal/projects/$projectId/edit'
import { Route as PortalProjectsProjectIdAddDatasetRouteImport } from './routes/portal/projects/$projectId/add-dataset'
import { Route as PortalDatasetsDatasetIdManagersRouteImport } from './routes/portal/datasets/$datasetId/managers'
import { Route as PortalDatasetsDatasetIdEditRouteImport } from './routes/portal/datasets/$datasetId/edit'
import { Route as PortalProjectsProjectIdDatasetsDatasetIdIndexRouteImport } from './routes/portal/projects/$projectId/datasets.$datasetId/index'
import { Route as PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRouteImport } from './routes/portal/projects/$projectId/datasets.$datasetId/add-columns'

const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRouteRoute = PortalRouteRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PortalUserRoute = PortalUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalDashboardRoute = PortalDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => PortalRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCreateAccountRoute = AuthCreateAccountRouteImport.update({
  id: '/auth/create-account',
  path: '/auth/create-account',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthConfirmEmailCodeRoute = AuthConfirmEmailCodeRouteImport.update({
  id: '/auth/confirm-email-code',
  path: '/auth/confirm-email-code',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalProjectsIndexRoute = PortalProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalDatasetsIndexRoute = PortalDatasetsIndexRouteImport.update({
  id: '/datasets/',
  path: '/datasets/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PublicDatasetsIndexRoute = PublicDatasetsIndexRouteImport.update({
  id: '/datasets/',
  path: '/datasets/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PortalProjectsCreateRoute = PortalProjectsCreateRouteImport.update({
  id: '/projects/create',
  path: '/projects/create',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalDatasetsCreateRoute = PortalDatasetsCreateRouteImport.update({
  id: '/datasets/create',
  path: '/datasets/create',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PublicDatasetsDatasetIdRoute = PublicDatasetsDatasetIdRouteImport.update({
  id: '/datasets/$datasetId',
  path: '/datasets/$datasetId',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PortalProjectsProjectIdIndexRoute =
  PortalProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalDatasetsDatasetIdIndexRoute =
  PortalDatasetsDatasetIdIndexRouteImport.update({
    id: '/datasets/$datasetId/',
    path: '/datasets/$datasetId/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalProjectsProjectIdUsersRoute =
  PortalProjectsProjectIdUsersRouteImport.update({
    id: '/projects/$projectId/users',
    path: '/projects/$projectId/users',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalProjectsProjectIdEditRoute =
  PortalProjectsProjectIdEditRouteImport.update({
    id: '/projects/$projectId/edit',
    path: '/projects/$projectId/edit',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalProjectsProjectIdAddDatasetRoute =
  PortalProjectsProjectIdAddDatasetRouteImport.update({
    id: '/projects/$projectId/add-dataset',
    path: '/projects/$projectId/add-dataset',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalDatasetsDatasetIdManagersRoute =
  PortalDatasetsDatasetIdManagersRouteImport.update({
    id: '/datasets/$datasetId/managers',
    path: '/datasets/$datasetId/managers',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalDatasetsDatasetIdEditRoute =
  PortalDatasetsDatasetIdEditRouteImport.update({
    id: '/datasets/$datasetId/edit',
    path: '/datasets/$datasetId/edit',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalProjectsProjectIdDatasetsDatasetIdIndexRoute =
  PortalProjectsProjectIdDatasetsDatasetIdIndexRouteImport.update({
    id: '/projects/$projectId/datasets/$datasetId/',
    path: '/projects/$projectId/datasets/$datasetId/',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRoute =
  PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRouteImport.update({
    id: '/projects/$projectId/datasets/$datasetId/add-columns',
    path: '/projects/$projectId/datasets/$datasetId/add-columns',
    getParentRoute: () => PortalRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/portal': typeof PortalRouteRouteWithChildren
  '/setup': typeof SetupRoute
  '/auth/confirm-email-code': typeof AuthConfirmEmailCodeRoute
  '/auth/create-account': typeof AuthCreateAccountRoute
  '/auth/login': typeof AuthLoginRoute
  '/portal/dashboard': typeof PortalDashboardRoute
  '/portal/user': typeof PortalUserRoute
  '/datasets/$datasetId': typeof PublicDatasetsDatasetIdRoute
  '/portal/datasets/create': typeof PortalDatasetsCreateRoute
  '/portal/projects/create': typeof PortalProjectsCreateRoute
  '/datasets/': typeof PublicDatasetsIndexRoute
  '/portal/datasets/': typeof PortalDatasetsIndexRoute
  '/portal/projects/': typeof PortalProjectsIndexRoute
  '/portal/datasets/$datasetId/edit': typeof PortalDatasetsDatasetIdEditRoute
  '/portal/datasets/$datasetId/managers': typeof PortalDatasetsDatasetIdManagersRoute
  '/portal/projects/$projectId/add-dataset': typeof PortalProjectsProjectIdAddDatasetRoute
  '/portal/projects/$projectId/edit': typeof PortalProjectsProjectIdEditRoute
  '/portal/projects/$projectId/users': typeof PortalProjectsProjectIdUsersRoute
  '/portal/datasets/$datasetId/': typeof PortalDatasetsDatasetIdIndexRoute
  '/portal/projects/$projectId/': typeof PortalProjectsProjectIdIndexRoute
  '/portal/projects/$projectId/datasets/$datasetId/add-columns': typeof PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRoute
  '/portal/projects/$projectId/datasets/$datasetId/': typeof PortalProjectsProjectIdDatasetsDatasetIdIndexRoute
}
export interface FileRoutesByTo {
  '/portal': typeof PortalRouteRouteWithChildren
  '/setup': typeof SetupRoute
  '/auth/confirm-email-code': typeof AuthConfirmEmailCodeRoute
  '/auth/create-account': typeof AuthCreateAccountRoute
  '/auth/login': typeof AuthLoginRoute
  '/portal/dashboard': typeof PortalDashboardRoute
  '/portal/user': typeof PortalUserRoute
  '/': typeof PublicIndexRoute
  '/datasets/$datasetId': typeof PublicDatasetsDatasetIdRoute
  '/portal/datasets/create': typeof PortalDatasetsCreateRoute
  '/portal/projects/create': typeof PortalProjectsCreateRoute
  '/datasets': typeof PublicDatasetsIndexRoute
  '/portal/datasets': typeof PortalDatasetsIndexRoute
  '/portal/projects': typeof PortalProjectsIndexRoute
  '/portal/datasets/$datasetId/edit': typeof PortalDatasetsDatasetIdEditRoute
  '/portal/datasets/$datasetId/managers': typeof PortalDatasetsDatasetIdManagersRoute
  '/portal/projects/$projectId/add-dataset': typeof PortalProjectsProjectIdAddDatasetRoute
  '/portal/projects/$projectId/edit': typeof PortalProjectsProjectIdEditRoute
  '/portal/projects/$projectId/users': typeof PortalProjectsProjectIdUsersRoute
  '/portal/datasets/$datasetId': typeof PortalDatasetsDatasetIdIndexRoute
  '/portal/projects/$projectId': typeof PortalProjectsProjectIdIndexRoute
  '/portal/projects/$projectId/datasets/$datasetId/add-columns': typeof PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRoute
  '/portal/projects/$projectId/datasets/$datasetId': typeof PortalProjectsProjectIdDatasetsDatasetIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_public': typeof PublicRouteRouteWithChildren
  '/portal': typeof PortalRouteRouteWithChildren
  '/setup': typeof SetupRoute
  '/auth/confirm-email-code': typeof AuthConfirmEmailCodeRoute
  '/auth/create-account': typeof AuthCreateAccountRoute
  '/auth/login': typeof AuthLoginRoute
  '/portal/dashboard': typeof PortalDashboardRoute
  '/portal/user': typeof PortalUserRoute
  '/_public/': typeof PublicIndexRoute
  '/_public/datasets/$datasetId': typeof PublicDatasetsDatasetIdRoute
  '/portal/datasets/create': typeof PortalDatasetsCreateRoute
  '/portal/projects/create': typeof PortalProjectsCreateRoute
  '/_public/datasets/': typeof PublicDatasetsIndexRoute
  '/portal/datasets/': typeof PortalDatasetsIndexRoute
  '/portal/projects/': typeof PortalProjectsIndexRoute
  '/portal/datasets/$datasetId/edit': typeof PortalDatasetsDatasetIdEditRoute
  '/portal/datasets/$datasetId/managers': typeof PortalDatasetsDatasetIdManagersRoute
  '/portal/projects/$projectId/add-dataset': typeof PortalProjectsProjectIdAddDatasetRoute
  '/portal/projects/$projectId/edit': typeof PortalProjectsProjectIdEditRoute
  '/portal/projects/$projectId/users': typeof PortalProjectsProjectIdUsersRoute
  '/portal/datasets/$datasetId/': typeof PortalDatasetsDatasetIdIndexRoute
  '/portal/projects/$projectId/': typeof PortalProjectsProjectIdIndexRoute
  '/portal/projects/$projectId/datasets/$datasetId/add-columns': typeof PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRoute
  '/portal/projects/$projectId/datasets/$datasetId/': typeof PortalProjectsProjectIdDatasetsDatasetIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/portal'
    | '/setup'
    | '/auth/confirm-email-code'
    | '/auth/create-account'
    | '/auth/login'
    | '/portal/dashboard'
    | '/portal/user'
    | '/datasets/$datasetId'
    | '/portal/datasets/create'
    | '/portal/projects/create'
    | '/datasets/'
    | '/portal/datasets/'
    | '/portal/projects/'
    | '/portal/datasets/$datasetId/edit'
    | '/portal/datasets/$datasetId/managers'
    | '/portal/projects/$projectId/add-dataset'
    | '/portal/projects/$projectId/edit'
    | '/portal/projects/$projectId/users'
    | '/portal/datasets/$datasetId/'
    | '/portal/projects/$projectId/'
    | '/portal/projects/$projectId/datasets/$datasetId/add-columns'
    | '/portal/projects/$projectId/datasets/$datasetId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/portal'
    | '/setup'
    | '/auth/confirm-email-code'
    | '/auth/create-account'
    | '/auth/login'
    | '/portal/dashboard'
    | '/portal/user'
    | '/'
    | '/datasets/$datasetId'
    | '/portal/datasets/create'
    | '/portal/projects/create'
    | '/datasets'
    | '/portal/datasets'
    | '/portal/projects'
    | '/portal/datasets/$datasetId/edit'
    | '/portal/datasets/$datasetId/managers'
    | '/portal/projects/$projectId/add-dataset'
    | '/portal/projects/$projectId/edit'
    | '/portal/projects/$projectId/users'
    | '/portal/datasets/$datasetId'
    | '/portal/projects/$projectId'
    | '/portal/projects/$projectId/datasets/$datasetId/add-columns'
    | '/portal/projects/$projectId/datasets/$datasetId'
  id:
    | '__root__'
    | '/_public'
    | '/portal'
    | '/setup'
    | '/auth/confirm-email-code'
    | '/auth/create-account'
    | '/auth/login'
    | '/portal/dashboard'
    | '/portal/user'
    | '/_public/'
    | '/_public/datasets/$datasetId'
    | '/portal/datasets/create'
    | '/portal/projects/create'
    | '/_public/datasets/'
    | '/portal/datasets/'
    | '/portal/projects/'
    | '/portal/datasets/$datasetId/edit'
    | '/portal/datasets/$datasetId/managers'
    | '/portal/projects/$projectId/add-dataset'
    | '/portal/projects/$projectId/edit'
    | '/portal/projects/$projectId/users'
    | '/portal/datasets/$datasetId/'
    | '/portal/projects/$projectId/'
    | '/portal/projects/$projectId/datasets/$datasetId/add-columns'
    | '/portal/projects/$projectId/datasets/$datasetId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
  PortalRouteRoute: typeof PortalRouteRouteWithChildren
  SetupRoute: typeof SetupRoute
  AuthConfirmEmailCodeRoute: typeof AuthConfirmEmailCodeRoute
  AuthCreateAccountRoute: typeof AuthCreateAccountRoute
  AuthLoginRoute: typeof AuthLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/portal/user': {
      id: '/portal/user'
      path: '/user'
      fullPath: '/portal/user'
      preLoaderRoute: typeof PortalUserRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/dashboard': {
      id: '/portal/dashboard'
      path: '/dashboard'
      fullPath: '/portal/dashboard'
      preLoaderRoute: typeof PortalDashboardRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/create-account': {
      id: '/auth/create-account'
      path: '/auth/create-account'
      fullPath: '/auth/create-account'
      preLoaderRoute: typeof AuthCreateAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/confirm-email-code': {
      id: '/auth/confirm-email-code'
      path: '/auth/confirm-email-code'
      fullPath: '/auth/confirm-email-code'
      preLoaderRoute: typeof AuthConfirmEmailCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/projects/': {
      id: '/portal/projects/'
      path: '/projects'
      fullPath: '/portal/projects/'
      preLoaderRoute: typeof PortalProjectsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/datasets/': {
      id: '/portal/datasets/'
      path: '/datasets'
      fullPath: '/portal/datasets/'
      preLoaderRoute: typeof PortalDatasetsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_public/datasets/': {
      id: '/_public/datasets/'
      path: '/datasets'
      fullPath: '/datasets/'
      preLoaderRoute: typeof PublicDatasetsIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/portal/projects/create': {
      id: '/portal/projects/create'
      path: '/projects/create'
      fullPath: '/portal/projects/create'
      preLoaderRoute: typeof PortalProjectsCreateRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/datasets/create': {
      id: '/portal/datasets/create'
      path: '/datasets/create'
      fullPath: '/portal/datasets/create'
      preLoaderRoute: typeof PortalDatasetsCreateRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_public/datasets/$datasetId': {
      id: '/_public/datasets/$datasetId'
      path: '/datasets/$datasetId'
      fullPath: '/datasets/$datasetId'
      preLoaderRoute: typeof PublicDatasetsDatasetIdRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/portal/projects/$projectId/': {
      id: '/portal/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/portal/projects/$projectId/'
      preLoaderRoute: typeof PortalProjectsProjectIdIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/datasets/$datasetId/': {
      id: '/portal/datasets/$datasetId/'
      path: '/datasets/$datasetId'
      fullPath: '/portal/datasets/$datasetId/'
      preLoaderRoute: typeof PortalDatasetsDatasetIdIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/projects/$projectId/users': {
      id: '/portal/projects/$projectId/users'
      path: '/projects/$projectId/users'
      fullPath: '/portal/projects/$projectId/users'
      preLoaderRoute: typeof PortalProjectsProjectIdUsersRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/projects/$projectId/edit': {
      id: '/portal/projects/$projectId/edit'
      path: '/projects/$projectId/edit'
      fullPath: '/portal/projects/$projectId/edit'
      preLoaderRoute: typeof PortalProjectsProjectIdEditRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/projects/$projectId/add-dataset': {
      id: '/portal/projects/$projectId/add-dataset'
      path: '/projects/$projectId/add-dataset'
      fullPath: '/portal/projects/$projectId/add-dataset'
      preLoaderRoute: typeof PortalProjectsProjectIdAddDatasetRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/datasets/$datasetId/managers': {
      id: '/portal/datasets/$datasetId/managers'
      path: '/datasets/$datasetId/managers'
      fullPath: '/portal/datasets/$datasetId/managers'
      preLoaderRoute: typeof PortalDatasetsDatasetIdManagersRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/datasets/$datasetId/edit': {
      id: '/portal/datasets/$datasetId/edit'
      path: '/datasets/$datasetId/edit'
      fullPath: '/portal/datasets/$datasetId/edit'
      preLoaderRoute: typeof PortalDatasetsDatasetIdEditRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/projects/$projectId/datasets/$datasetId/': {
      id: '/portal/projects/$projectId/datasets/$datasetId/'
      path: '/projects/$projectId/datasets/$datasetId'
      fullPath: '/portal/projects/$projectId/datasets/$datasetId/'
      preLoaderRoute: typeof PortalProjectsProjectIdDatasetsDatasetIdIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/projects/$projectId/datasets/$datasetId/add-columns': {
      id: '/portal/projects/$projectId/datasets/$datasetId/add-columns'
      path: '/projects/$projectId/datasets/$datasetId/add-columns'
      fullPath: '/portal/projects/$projectId/datasets/$datasetId/add-columns'
      preLoaderRoute: typeof PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRouteImport
      parentRoute: typeof PortalRouteRoute
    }
  }
}

interface PublicRouteRouteChildren {
  PublicIndexRoute: typeof PublicIndexRoute
  PublicDatasetsDatasetIdRoute: typeof PublicDatasetsDatasetIdRoute
  PublicDatasetsIndexRoute: typeof PublicDatasetsIndexRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicIndexRoute: PublicIndexRoute,
  PublicDatasetsDatasetIdRoute: PublicDatasetsDatasetIdRoute,
  PublicDatasetsIndexRoute: PublicDatasetsIndexRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

interface PortalRouteRouteChildren {
  PortalDashboardRoute: typeof PortalDashboardRoute
  PortalUserRoute: typeof PortalUserRoute
  PortalDatasetsCreateRoute: typeof PortalDatasetsCreateRoute
  PortalProjectsCreateRoute: typeof PortalProjectsCreateRoute
  PortalDatasetsIndexRoute: typeof PortalDatasetsIndexRoute
  PortalProjectsIndexRoute: typeof PortalProjectsIndexRoute
  PortalDatasetsDatasetIdEditRoute: typeof PortalDatasetsDatasetIdEditRoute
  PortalDatasetsDatasetIdManagersRoute: typeof PortalDatasetsDatasetIdManagersRoute
  PortalProjectsProjectIdAddDatasetRoute: typeof PortalProjectsProjectIdAddDatasetRoute
  PortalProjectsProjectIdEditRoute: typeof PortalProjectsProjectIdEditRoute
  PortalProjectsProjectIdUsersRoute: typeof PortalProjectsProjectIdUsersRoute
  PortalDatasetsDatasetIdIndexRoute: typeof PortalDatasetsDatasetIdIndexRoute
  PortalProjectsProjectIdIndexRoute: typeof PortalProjectsProjectIdIndexRoute
  PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRoute: typeof PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRoute
  PortalProjectsProjectIdDatasetsDatasetIdIndexRoute: typeof PortalProjectsProjectIdDatasetsDatasetIdIndexRoute
}

const PortalRouteRouteChildren: PortalRouteRouteChildren = {
  PortalDashboardRoute: PortalDashboardRoute,
  PortalUserRoute: PortalUserRoute,
  PortalDatasetsCreateRoute: PortalDatasetsCreateRoute,
  PortalProjectsCreateRoute: PortalProjectsCreateRoute,
  PortalDatasetsIndexRoute: PortalDatasetsIndexRoute,
  PortalProjectsIndexRoute: PortalProjectsIndexRoute,
  PortalDatasetsDatasetIdEditRoute: PortalDatasetsDatasetIdEditRoute,
  PortalDatasetsDatasetIdManagersRoute: PortalDatasetsDatasetIdManagersRoute,
  PortalProjectsProjectIdAddDatasetRoute:
    PortalProjectsProjectIdAddDatasetRoute,
  PortalProjectsProjectIdEditRoute: PortalProjectsProjectIdEditRoute,
  PortalProjectsProjectIdUsersRoute: PortalProjectsProjectIdUsersRoute,
  PortalDatasetsDatasetIdIndexRoute: PortalDatasetsDatasetIdIndexRoute,
  PortalProjectsProjectIdIndexRoute: PortalProjectsProjectIdIndexRoute,
  PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRoute:
    PortalProjectsProjectIdDatasetsDatasetIdAddColumnsRoute,
  PortalProjectsProjectIdDatasetsDatasetIdIndexRoute:
    PortalProjectsProjectIdDatasetsDatasetIdIndexRoute,
}

const PortalRouteRouteWithChildren = PortalRouteRoute._addFileChildren(
  PortalRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  PublicRouteRoute: PublicRouteRouteWithChildren,
  PortalRouteRoute: PortalRouteRouteWithChildren,
  SetupRoute: SetupRoute,
  AuthConfirmEmailCodeRoute: AuthConfirmEmailCodeRoute,
  AuthCreateAccountRoute: AuthCreateAccountRoute,
  AuthLoginRoute: AuthLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
